module.exports = __webpack_public_path__ + "img/Support.077f09f.png";